


export const MANAGE_EXTERNALUSERS = 'manageExternalUser';
export const GET_MANAGE_EXTERNALUSERS = `${MANAGE_EXTERNALUSERS}/getManageExternalUserAction`;
export const SET_MANAGE_EMPLOYEE_UPDATE_STATUS = `${MANAGE_EXTERNALUSERS}/setUpdateStatusExternalAction`;

